import { Location } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTab, MatTabContent, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { AvatarComponent } from '../../../../shared/components/avatar/avatar.component';
import { DotsLoaderComponent } from '../../../../shared/components/dots-loader/dots-loader.component';
import { TopNavComponent } from '../../../../shared/containers/top-nav/top-nav.component';
import { ClickCursorDirective } from '../../../../shared/directives/click-cursor.directive';
import { RootVariantsCountStore } from '../../../../store/root-variants-count.signal-store';
import { UserDetails } from '../../../auth0/models';
import { Auth0Store } from '../../../auth0/store';
import { UserUtils } from '../../../auth0/utils/user.utils';
import { MembersComponent } from '../../components/members/members.component';
import { OrganizationInfoComponent } from '../../components/organization-info/organization-info.component';
import { ProfileDetailsComponent } from '../../components/profile-details/profile-details.component';
import { RolesPermissionsComponent } from '../../components/roles-permissions/roles-permissions.component';

@Component({
  selector: 'gnx-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss'],
  imports: [
    TopNavComponent,
    ClickCursorDirective,
    DotsLoaderComponent,
    AvatarComponent,
    MatTabGroup,
    MatTab,
    MatTabContent,
    MatTabLabel,
    MatTooltip,
    ProfileDetailsComponent,
    OrganizationInfoComponent,
    MembersComponent,
    RolesPermissionsComponent,
  ],
})
export class SettingsPageComponent implements OnInit {
  location = inject(Location);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  protected auth0Store = inject(Auth0Store);
  protected variantsCountStore = inject(RootVariantsCountStore);
  pageLoading = true;
  userDetails: UserDetails;
  isAdmin: boolean;
  selectedTabIndex = 0;

  private destroyRef = inject(DestroyRef);

  get showRolesPermissions(): boolean {
    return this.userDetails?.org_config?.userConfig?.rolesAndPermissionsConfig?.active ?? false;
  }

  readonly tabSlugs = ['profile', 'organization', 'members', 'roles-permissions'];

  ngOnInit() {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const user = this.auth0Store.userDetails();
      if (user) {
        this.userDetails = user;
        this.pageLoading = false;
        this.isAdmin = UserUtils.isUserAnAdmin(user);
        const tabIndex = this.tabSlugs.indexOf(params['tab']);
        this.selectedTabIndex = tabIndex >= 0 ? tabIndex : 0;
      }
    });

    this.variantsCountStore.loadUserVariantsCount();
  }

  onTabChange(index: number): void {
    this.router.navigate(['/settings', this.tabSlugs[index]], { replaceUrl: true });
  }
}
